import "client-only"

import { ConfigParams, getConfigParams } from "@/lib/get-config-params"
import { useSearchParams } from "next/navigation"

/* Hook to get the configuration parameters from the URL */
export function useConfigParams(): ConfigParams {
  const searchParams = useSearchParams()
  return getConfigParams(searchParams)
}
